module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-modal', {
    ref: "missionConvertToSlotTemplateModal",
    attrs: {
      "id": "missionConvertToSlotTemplateModal",
      "title": _vm.$t('mission.modal.convert.slotTemplate'),
      "no-close-on-backdrop": ""
    },
    on: {
      "shown": _vm.clearMissionConvertToSlotTemplateData
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('b-form', {
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.convertMissionToSlotTemplate($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('mission.convert.slotTemplate.description'))
    }
  })])]), _vm._v(" "), _c('hr', {
    staticClass: "my-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.title'),
      "state": _vm.missionConvertToSlotTemplateTitleState,
      "feedback": _vm.missionConvertToSlotTemplateTitleFeedback,
      "description": _vm.$t('mission.slotTemplate.title.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "required": ""
    },
    model: {
      value: (_vm.missionConvertToSlotTemplateData.title),
      callback: function($$v) {
        _vm.missionConvertToSlotTemplateData.title = $$v
      },
      expression: "missionConvertToSlotTemplateData.title"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.visibility'),
      "state": "success",
      "description": _vm.$t('mission.slotTemplate.visibility.description')
    }
  }, [_c('b-form-select', {
    staticClass: "mb-3",
    attrs: {
      "options": _vm.missionConvertToSlotTemplateVisibilityOptions,
      "required": ""
    },
    model: {
      value: (_vm.missionConvertToSlotTemplateData.visibility),
      callback: function($$v) {
        _vm.missionConvertToSlotTemplateData.visibility = $$v
      },
      expression: "missionConvertToSlotTemplateData.visibility"
    }
  })], 1)], 1)])])], 1), _vm._v(" "), _c('div', {
    slot: "modal-footer"
  }, [_c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group",
      "aria-label": "Mission convert to slot template actions"
    }
  }, [_c('b-btn', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.convertMissionToSlotTemplate
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.submit')) + "\n        ")]), _vm._v(" "), _c('b-btn', {
    on: {
      "click": _vm.hideMissionConvertToSlotTemplateModal
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.cancel')) + "\n        ")])], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f8b20de"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/missions/modals/MissionConvertToSlotTemplateModal.vue
// module id = 518
// module chunks = 0